import { render, staticRenderFns } from "./PenilaianResiko.vue?vue&type=template&id=1493626c&lang=pug&"
import script from "./PenilaianResiko.vue?vue&type=script&lang=js&"
export * from "./PenilaianResiko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports